var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { utils } from '../..';
var ProgressBarContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n  width: 100%;\n  border-radius: 45px;\n  background-color: ", ";\n"], ["\n  height: ", "px;\n  width: 100%;\n  border-radius: 45px;\n  background-color: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height || 4;
}, function (_a) {
    var theme = _a.theme, customBackgroundColor = _a.customBackgroundColor;
    return customBackgroundColor || utils.hexToRGBA(theme.colors.neutral7, theme.alpha.medium);
});
var ProgressBarFill = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: ", "%;\n  ", "\n\n  border-radius: inherit;\n  text-align: right;\n"], ["\n  height: 100%;\n  width: ", "%;\n  ", "\n\n  border-radius: inherit;\n  text-align: right;\n"])), function (_a) {
    var percentage = _a.percentage;
    return Math.min(1, percentage) * 100;
}, function (_a) {
    var isGradient = _a.isGradient, funded = _a.funded, theme = _a.theme, customColor = _a.customColor;
    return isGradient
        ? "  background-image: linear-gradient(90deg, #5349ed 17.53%, #b949ed 84.49%, ".concat(theme.colors.gitdPink, " 101.86%);\n    ")
        : "background-color: ".concat(customColor || (funded ? theme.colors.secondary : theme.colors.primary), ";");
});
var ProgressBar = function (_a) {
    var percentage = _a.percentage, funded = _a.funded, height = _a.height, customColor = _a.customColor, customBackgroundColor = _a.customBackgroundColor, isGradient = _a.isGradient;
    return (_jsx(ProgressBarContainer, { height: height, customBackgroundColor: customBackgroundColor, children: _jsx(ProgressBarFill, { percentage: percentage, funded: funded, customColor: customColor, isGradient: isGradient }) }));
};
export default ProgressBar;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map